export function getDistance(locationLat, locationLon, userLat, userLon) {
	let latDifference = Math.abs(locationLat - userLat)
	let lonDifference = Math.abs(locationLon - userLon)

	let latitudeLength = 69.172
	let longitudeLength = Math.cos(locationLat * Math.PI / 180.0) * latitudeLength

	let latMiles = latDifference * latitudeLength
	let lonMiles = lonDifference * longitudeLength

	let distance = Math.round(
		Math.sqrt(Math.pow(latMiles, 2) + Math.pow(lonMiles, 2))
	)

	return distance
}

export function deepCloneArray(array) {
	return JSON.parse(JSON.stringify(array))
}

export function findElementByLabel(field) {
	return document.querySelector(
		'.hosted-field--label[for="' + field.container.id + '"]'
	)
}

export function getAddressStringFromObject(location) {
	let locationString = ''
	if (location.hasOwnProperty('address')) {
		let addressComponents = []
		if (location.address.hasOwnProperty('street_number')) {
			if (location.address.hasOwnProperty('route')) {
				addressComponents.push(
					location.address.street_number + ' ' + location.address.route
				)
			}
		}
		if (location.address.hasOwnProperty('neighborhood')) {
			if (location.address.neighborhood !== '') {
				addressComponents.push(location.address.neighborhood)
			}
		}
		if (location.address.hasOwnProperty('city')) {
			addressComponents.push(location.address.city)
		}
		if (location.address.hasOwnProperty('state')) {
			addressComponents.push(location.address.state)
		}
		if (location.address.hasOwnProperty('country')) {
			if (location.address.country !== 'United States') {
				addressComponents.push(location.address.country)
			}
		}
		for (var i = 0; i < addressComponents.length; i++) {
			locationString += addressComponents[i]
			if (i < addressComponents.length - 1) {
				locationString += ', '
			}
		}
	}
	return locationString
}

export function get12hTimeString(time) {
	let timeArray = time.split(':')
	let timeString = ''
	let stringEnd = ''
	if (parseInt(timeArray[0]) < 12) {
		timeString += String(parseInt(timeArray[0]))
		stringEnd = 'AM'
	} else if (parseInt(timeArray[0]) === 12) {
		timeString += String(parseInt(timeArray[0]))
		stringEnd = 'PM'
	} else {
		timeString += String(parseInt(timeArray[0]) - 12)
		stringEnd = 'PM'
	}
	if (parseInt(timeArray[1]) !== 0) {
		timeString += ':' + String(parseInt(timeArray[1]))
	}
	timeString += '' + stringEnd
	return timeString
}